import "./kendo.data.aspnetmvc.js";

(function($, undefined) {
    let kendo = window.kendo,
        ui = kendo.ui;

    if (ui && ui.DropDownList) {
        ui.DropDownList.requestData = function(selector, cascadeFrom) {
            let dropdownlist = $(selector).data("kendoDropDownList");

            if (!dropdownlist) {
                return;
            }

            let filter = dropdownlist.dataSource.filter(),
                filterInput = dropdownlist.filterInput,
                value = filterInput ? filterInput.val() : "";

            if (!filter || !filter.filters.length) {
                value = "";
            }

            let data = {
                text: value
            };

            if(cascadeFrom != null && cascadeFrom.trim()) {
                data["cascadeFrom"] = $(`#${cascadeFrom}`).val();
            }

            return data;
        };
    }

})(window.kendo.jQuery);
